module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bmh"
  }, [_c('span', {
    staticClass: "epub-script"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("My friend Florence Olian for “How I’m Going to Make It to One Hundred.”")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Virginia Kiser Hotchner for suggesting the title and much more.")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Claire Panke and Anna Harding for their painstaking assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Tracy and Holly Hotchner for bringing Ernie into my life.")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Dr. Norman Kelman, in memorium.")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Washington University Alumni Office")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Andrew Padula, former V.P. for Production, Bigelow Tea Co., for his recollections.")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Kathryn Huck for making the demands of editing this book a piece of St. Martin’s cake.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51cc83bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgements.vue
// module id = 72
// module chunks = 0